import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Features from "./pages/Features";
import Contact from "./pages/Contact";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DashboardOverview from "./pages/DashboardOverview"; // Default dashboard view
import History from "./pages/History";
import TopUp from "./pages/TopUp";
import Profile from "./pages/Profile";
import Referrals from "./pages/Referrals";
import Support from "./pages/Support";
import ForgotPassword from "./pages/forgotPassword";
import ResetPassword from "./pages/resetPassword";
import NotFound from "./pages/notFound";
import ProtectedRoute from './components/ProtectedRoute'

const App = () => {
  // const { isAuthenticated, logout } = useAuth(); // ✅ Use centralized auth state

  // List of routes where Header/Footer should not render
  const noHeaderFooterRoutes = ["/signup", "/404", "/reset-password", "/forgot-password", "/login", "/dashboard", "/dashboard/history", "/dashboard/topup", "/dashboard/profile", "/dashboard/support"];

  
  // Custom Layout Component
  const Layout = ({ children }) => {
    const location = useLocation();
    const isActiveRoute = (path) => {
      return location.pathname === path;
    };
    const hideHeaderFooter = noHeaderFooterRoutes.some((route) => location.pathname.startsWith(route));

    return (
      <>
        {!hideHeaderFooter && <Header isActiveRoute={isActiveRoute} />}
        <main className="flex-grow">{children}</main>
        {!hideHeaderFooter && <Footer />}
      </>
    );
  };

  return (
    <Router>
      <Layout>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login  />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<DashboardOverview />} /> {/* Default view */}
            <Route path="history" element={<History />} />
            <Route path="topup" element={<TopUp />} />
            <Route path="profile" element={<Profile />} />
            <Route path="support" element={<Support />} />
            <Route path="referrals" element={<Referrals />} />
          </Route>
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
